var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6843_2222)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_6843_2222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8427 50.3534L29.2576 40.342C28.9771 39.7296 29.0582 38.9677 29.4578 38.4612L34.0429 32.6498C34.564 31.9893 35.4356 31.9893 35.9568 32.6498L40.5419 38.4612C40.9415 38.9677 41.0226 39.7296 40.7421 40.342L36.157 50.3534C35.6533 51.4531 34.3463 51.4531 33.8427 50.3534Z",
    fill: "#FFF8DE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.2617 49.5423C17.2617 48.7 17.9652 48.0172 18.8329 48.0172H51.1737C52.0415 48.0172 52.7449 48.7 52.7449 49.5423V55.6337C52.7449 56.4759 52.0415 57.1587 51.1737 57.1587H18.8329C17.9652 57.1587 17.2617 56.4759 17.2617 55.6337V49.5423Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2485 24.9449L32.3025 10.7487C33.4173 8.50532 36.5848 8.50532 37.6995 10.7487L44.7536 24.9449C45.5959 26.64 47.7473 27.1563 49.2534 26.0248L54.9567 21.7398C57.0822 20.1428 60.0668 21.8882 59.7571 24.5471L56.6273 51.422C56.4482 52.9594 55.1594 54.118 53.6281 54.118H16.3739C14.8427 54.118 13.5538 52.9594 13.3748 51.422L10.2449 24.5471C9.93528 21.8882 12.9198 20.1428 15.0454 21.7398L20.7487 26.0248C22.2547 27.1563 24.4062 26.64 25.2485 24.9449Z",
    fill: "url(#paint0_radial_6843_2222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6287 30.9754C33.8378 29.4245 36.1631 29.4245 37.3722 30.9754L42.052 36.978C42.9161 38.0864 42.9161 39.6492 42.052 40.7577L37.3722 46.7603C36.1631 48.3111 33.8378 48.3111 32.6287 46.7603L27.9489 40.7577C27.0847 39.6492 27.0847 38.0864 27.9489 36.978L32.6287 30.9754Z",
    fill: "url(#paint1_radial_6843_2222)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6843_2222",
    x: -1.44401,
    y: -2.6005,
    width: 72.89,
    height: 71.4259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.83333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.780392 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6843_2222"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6843_2222",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_6843_2222",
    x: 17.4251,
    y: 23.4044,
    width: 35.1493,
    height: 42.3571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.91667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.83333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6843_2222"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6843_2222",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.91667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.91667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.914286 0 0 0 0 0.55 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6843_2222"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6843_2222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9028 26.9344) rotate(56.9028) scale(32.4486 28.8778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#FFC839"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6843_2222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9119 35.3068) rotate(65.4804) scale(12.1988 12.992)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3E12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownIcon);
export default __webpack_public_path__ + "static/media/crown-icon.ee60c0f9f7155a633da266d65ef5e822.svg";
export { ForwardRef as ReactComponent };